import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-address-card',
  templateUrl: './address-card.component.html',
  styleUrls: ['./address-card.component.sass'],
})
export class AddressCardComponent implements OnInit {
  constructor() {
    /* */
  }

/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
  ngOnInit(): void {
    //
  }
/* eslint-enable @angular-eslint/no-empty-lifecycle-method */
}
